import React, { forwardRef } from 'react';
import styled from 'styled-components';

const DropzoneStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed;
  padding: 2rem;
  border-radius: 1rem;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  img {
    max-width: 100%;
  }
`;

const Dropzone = forwardRef((props, ref) => {
  return (
    <DropzoneStyled ref={ref} {...props}>
      {props.children}
    </DropzoneStyled>
  );
});

export default Dropzone;
